import type { InventoryFilterForm } from '@/types/inventory';

export function shouldReturnToInventoryList(
  canOpenCreate: boolean,
  filterData: InventoryFilterForm | null | undefined
): boolean {
  return !canOpenCreate || !filterData;
}

export function depotIdFromInventoryFilter(
  filterData: InventoryFilterForm | null | undefined
): number | null {
  return filterData?.depot?.id ?? null;
}
